import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { PasswordRecoveryPayload, PasswordResetPayload } from './types';
import { Fail } from '../../types';

export const passwordRecoveryRequest = action(
  'PASSWORD_RECOVERY_REQUEST',
  withPayload<PasswordRecoveryPayload>(),
);

export const passwordRecoverySuccess = action(
  'PASSWORD_RECOVERY_SUCCESS',
  withoutPayload,
);

export const passwordRecoveryFail = action(
  'PASSWORD_RECOVERY_FAIL',
  withPayload<Fail>(),
);

export const resendPasswordRecoveryRequest = action(
  'RESEND_PASSWORD_RECOVERY_REQUEST',
  withPayload<string>(),
);

export const resendPasswordRecoverySuccess = action(
  'RESEND_PASSWORD_RECOVERY_SUCCESS',
  withoutPayload,
);

export const resendPasswordRecoveryFail = action(
  'RESEND_PASSWORD_RECOVERY_FAIL',
  withPayload<Fail>(),
);

export const resetForm = action(
  'RESET_PASSWORD_RECOVERY_FORM',
  withoutPayload,
);

export const passwordResetRequest = action(
  'PASSWORD_RESET_REQUEST',
  withPayload<PasswordResetPayload>(),
);

export const passwordResetSuccess = action(
  'PASSWORD_RESET_SUCCESS',
  withoutPayload,
);

export const passwordResetFail = action(
  'PASSWORD_RESET_FAIL',
  withPayload<Fail>(),
);

export const resetChanged = action(
  'RESET_PASSWORD_RECOVER_CHANGED',
  withoutPayload,
);
